module.exports = "<div class=\"q-marg-bottom-xl q-marg-top-xs-at-md q-marg-horz-xl q-pad-vert-xs\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=\"q-col-10 q-no-pad\"> Filters: <span class=applied-filter-pills></span> </div> {% if (canEdit === true) { %} <div class=\"q-col-2 q-no-pad-at-md q-no-pad-right\"> <a href=# class=\"base-btn v2-btn purple-btn q-pull-right-til-md q-block-at-md q-text-center-at-md q-marg-vert-md-at-md js-manage-view-modal-open\"> Manage View </a> </div> {% } %} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/appliedFilterBar.html
// module id = 1140
// module chunks = 1